import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopPage = _resolveComponent("TopPage", true)!

  return (_openBlock(), _createBlock(_component_TopPage, {
    collections: _ctx.collections,
    imageQueries: _ctx.imageQueries
  }, null, 8, ["collections", "imageQueries"]))
}